import { render, staticRenderFns } from "./OrderAnalytic.vue?vue&type=template&id=58246743&"
import script from "./OrderAnalytic.vue?vue&type=script&lang=js&"
export * from "./OrderAnalytic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports